// extracted by mini-css-extract-plugin
export default {"row":"DocumentTypeField-module--row--Se_TA","value":"DocumentTypeField-module--value--I6YD2"};